import React, { Component } from 'react';
import Footer from '../components/statics/footer';
import {
  Container,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Collapse,
} from 'reactstrap';

import './faqScreen.css';
import { getQuestions } from '../providers/faqProvider';

class FAQScreen extends Component {
  constructor(props){
    super(props);
    this.state = {
      list: [],
      selected: null,
    }
  }

  async componentDidMount(){
      const result = await getQuestions();
      if(result.error){
        return;
      }
      console.log(result);
      
      this.setState({list:result});
  }

  selectQuestion(index) {

    if(index === this.state.selected){
      this.setState({selected: null});
      return;
    }

    this.setState({selected: index});
  }

  render() {
      return (
        <React.Fragment>
            <main className="faq-container">
                <Container>
                    <h1>Perguntas Frequentes</h1>
                    <div className="profile-card">
                      {this.state.list.map((item, i) => (
                        <Card key={i} className="faq-card">
                          <CardHeader onClick={() => this.selectQuestion(i)} className="faq-header">
                            {i === this.state.selected ? (
                              <span className="selected">{item.title}</span>
                            ) : <span>{item.title}</span>}
                            
                          </CardHeader>
                          <Collapse isOpen={i === this.state.selected}>
                            <CardBody>
                              <CardText>{item.description}</CardText>
                            </CardBody>
                          </Collapse>
                        </Card>
                      ))}
                    </div>
                </Container>
            </main>
            <Footer />
        </React.Fragment>
      );
}
}

export default FAQScreen;
